import React from 'react';
import './MultimediaTaskHelpModal.css';

interface MultimediaTaskHelpModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const MultimediaTaskHelpModal: React.FC<MultimediaTaskHelpModalProps> = ({
  isOpen,
  onClose,
}) => {
  if (!isOpen) return null;

  return (
    <div className="multimedia-help-modal-overlay" onClick={onClose}>
      <div className="multimedia-help-modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="multimedia-help-modal-close" onClick={onClose} aria-label="Close help modal">
          ✕
        </button>
        <div className="multimedia-help-modal-header">
          <h2>📋 Multimedia Task Instructions</h2>
        </div>
        <div className="multimedia-help-modal-body">
          <div className="help-section">
            <h3>Understanding Multimedia Tasks</h3>
            <p>
              Some tasks require you to reference the chat application on the AI's computer to
              understand what needs to be done. The task description alone may not contain all
              the information needed.
            </p>
          </div>

          <div className="help-section">
            <h3>Example Task</h3>
            <div className="help-example">
              "Complete the task that Richard requested in October and save your result as notes.pdf."
            </div>
            <p>
              In this case, you'll need to check the chat messages to find out what Richard
              requested in October.
            </p>
          </div>

          <div className="help-section">
            <h3>How to Access the Computer</h3>
            <ol>
              <li>Click the <strong>"Open Computer"</strong> button to view the AI's desktop</li>
              <li>Log into Mattermost with:
                <ul className="credentials-list">
                  <li><strong>Username:</strong> <code>li.na</code></li>
                  <li><strong>Password:</strong> <code>password</code></li>
                </ul>
              </li>
              <li>Read through the messages to understand what task needs to be completed</li>
            </ol>
          </div>

          <div className="help-section">
            <h3>Downloading Files from Mattermost</h3>
            <p>
              If you need to download files that were shared in Mattermost to complete the task,
              use the <strong>"Export Mattermost Media Files"</strong> button in the computer view.
              This will download all media files shared in the chat.
            </p>
          </div>

          <div className="help-section">
            <h3>Comparing Solutions</h3>
            <p>
              The output format remains unchanged. Continue using the side-by-side viewer to
              compare your solution files against the AI's files, just as you would with
              regular tasks.
            </p>
          </div>

          <div className="help-actions">
            <button className="help-dismiss-btn" onClick={onClose}>
              Got it!
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MultimediaTaskHelpModal;
